import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MDBSwitchService {
    public onValueChanges: Subject<{
        id: string,
        value: boolean,
        options?: {
            onlySelf?: boolean;
            emitEvent?: boolean;
            emitModelToViewChange?: boolean;
            emitViewToModelChange?: boolean;
        }
    }> = new Subject();

    public onStatusChanges: Subject<{
        id: string,
        disabled: boolean,
        options?: {
            onlySelf?: boolean;
            emitEvent?: boolean;
        }
    }> = new Subject();
    
    constructor() {}

    setValue(id, value, options?: {
        onlySelf?: boolean;
        emitEvent?: boolean;
    }) {
        this.onValueChanges.next({ id, value, options })
    }

    disable(id, options?: {
        onlySelf?: boolean;
        emitEvent?: boolean;
    }) {
        this.onStatusChanges.next({ id, disabled: true, options });
    }

    enable(id, options?: {
        onlySelf?: boolean;
        emitEvent?: boolean;
    }) {
        this.onStatusChanges.next({ id, disabled: false, options });
    }
}
